import http from "@/shared/services/http";

export const statisticCustomer = (params: any) => http.get(`v1/dashboard/statistic-customer`, { params });
export const statisticEmployee = (params: any) => http.get(`v1/dashboard/statistic-employee`, { params });
export const statisticPartner = (params: any) => http.get(`v1/dashboard/statistic-partner`, { params });
export const statisticLading = (params: any) => http.get(`v1/dashboard/statistic-lading`, { params });
export const chartLading = (params: any) => http.get(`v1/dashboard/chart-lading`, { params });
export const statisticRow2 = (params: any) => http.get(`v1/dashboard/statistic-row2`, { params })
export const statisticRow3 =() => http.get(`v1/warehouses/statistic`)
